export const COUNTRY_CODES = [
  'PL',
  'DE',
  'FR',
  'IT',
  'ES',
  'PT',
  'NL',
  'BE',
  'LU',
  'GB',
  'IE',
  'AT',
  'CZ',
  'SK',
  'HU',
  'RO',
  'BG',
  'GR',
  'SE',
  'DK',
  'NO',
  'FI',
  'CH',
  'LI',
  'EE',
  'LV',
  'LT',
  'HR',
  'SI',
  'CY',
  'MT',
] as const;

export type CountryCode = (typeof COUNTRY_CODES)[number];

export function countryOptions(locale: string): { value: string; label: string }[] {
  let displayNames: Intl.DisplayNames | null = null;
  try {
    displayNames = new Intl.DisplayNames([locale], { type: 'region' });
  } catch {
    displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
  }
  return COUNTRY_CODES.map((code) => ({
    value: code,
    label: displayNames?.of(code) ?? code,
  })).sort((a, b) => a.label.localeCompare(b.label, locale));
}
